import React from "react";

const NFT = () => {
  return (
    <>
      <div className="docs article area">
        <h3 className="docs-text title">What is an NFT?</h3>

        <p className="docs-text">
          <h6 className="docs-text title">According to Ethereum.org:</h6>
          
          "NFTs are tokens that we can use to represent ownership of unique
          items. They let us tokenise things like art, collectibles, even real
          estate. They can only have one official owner at a time and they're
          secured by the Ethereum blockchain – no one can modify the record of
          ownership or copy/paste a new NFT into existence.
          <br></br>
          <br></br>
          NFT stands for non-fungible token. Non-fungible is an economic term
          that you could use to describe things like your furniture, a song
          file, or your computer. These things are not interchangeable for other
          items because they have unique properties.
          <br></br>
          <br></br>
          Fungible items, on the other hand, can be exchanged because their
          value defines them rather than their unique properties. For example,
          ETH or dollars are fungible because 1 ETH / $1 USD is exchangeable for
          another 1 ETH / $1 USD."
        </p>

        <h3 className="docs-text title">Okay, but why?</h3>
        <p className="docs-text">
          There are many reasons for making an NFT. The majority of people using
          the internet today might not yet have a practical use case, but
          blockchain technology is still in it's younger years. I didn't even
          know what an NFT was until a friend jokingly brought them up two weeks
          before I started on this project.
          <br></br>
          <br></br>
          For online artists and content creators an NFT brings a layer of value
          to something intangible. For young lovers, a permenant piece of data
          on the blockchain can represent their immutable love. For gamers they
          are a unique reward to showcase their digital accomplishments. To me,
          it was an itroduction to an exciting new internet.
          <br></br>
          <br></br>
          What I personally think brought a rise to their recent boom in
          popularity is the "clout" earned from owning something rare.
          Validation of uniqueness and rarity to something that was previously
          easily duplicated. In a post pandemic world, NFTs were made puplar by
          a new breed of sneaker-heads, art collectors and an increasing need
          inside all of us for digital individualism for our digital personas.
        </p>
      </div>
    </>
  );
};

export default NFT;
